import classes from './FinanceAndBanking.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../components/formCard/FormCard.tsx";
import {Link} from "react-scroll";
// todo maybe not eroad
import eRoadImg from '../../media/projects/e-road.webp'
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const FinanceAndBanking = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();

    const title = t('financeAndBanking.title')
    const description = t('financeAndBanking.text', {returnObjects: true})

    const blackBlocks = t('financeAndBanking.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('financeAndBanking.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('financeAndBanking.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('financeAndBanking.benefitBlocks', {returnObjects: true})

    const stories = t('financeAndBanking.stories', {returnObjects: true})

    return (
        <>
            <Helmet>
                <title>
                    Finance & Banking Software Development | FinTech Solutions – Goteco
                </title>
                <meta
                    name="description"
                    content="Secure and scalable banking software development for fintechs and financial institutions. Build core banking systems, mobile banking apps, and fraud detection platforms."
                />
                <link rel="canonical" href="https://go-te.co/industries/finance-and-banking" />
            </Helmet>
            <main>
                <Heading title={title} description={description} maxWidth={680}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('financeAndBanking.blackBlocksTitle')}</h3>
                        <p>{t('financeAndBanking.blackBlocksText')}</p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon, title}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text} title={title}/>))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('financeAndBanking.challengesBlocksTitle')}</h2>
                    </div>

                    <div>
                        {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                         text={text} key={title}/>)}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('financeAndBanking.solutionsBlocksTitle')}</h2>
                    </div>

                    <div>
                        {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>)}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('financeAndBanking.benefitBlocksTitle')}</h2>
                    </div>

                    <div>
                        {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text}
                                                                                 key={title}/>)}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('financeAndBanking.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                     key={title}/>)}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                    <div className={classes.content}>
                        <div className={classes['text-block']}>
                            <h2>{t('financeAndBanking.useCase')}</h2>
                            <div className={classes.text}>
                                {/*todo add link on image*/}
                                <img alt="" src={eRoadImg}/>
                                <p>{t('financeAndBanking.useCaseSubtitle')}</p>
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <span>{t('financeAndBanking.useCaseText')}</span>
                            <Link className={classes.link} smooth={true} to={'contact'}>
                                {t('financeAndBanking.useCaseButton')}
                            </Link>
                        </div>
                    </div>
                    <img alt="" className={classes.img} src={eRoadImg}/>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard 
                    title={t('financeAndBanking.formCard.title')}
                    message={t('financeAndBanking.formCard.message')}
                    buttonText={t('financeAndBanking.formCard.buttonText')}
                    labels={t('financeAndBanking.formCard.labels', {returnObjects: true})}
                    top={3} id='contact'/>
                </section>
            </main>
        </>

    );
};

export default FinanceAndBanking;
